import { nanoid } from "@reduxjs/toolkit"
import { Button } from "react-bootstrap"
import { useSelector } from "react-redux"
import { Channel, Obstacle, Point, RootState, Settings } from ".."
import { Geometry } from "../Utils/Geometry"
import { V } from '../Utils/Vector'

export { Download }

function Download(props: {

}) {

  const inputConfiguration = useSelector((state: RootState) => state.inputConfiguration)
  const outputConfiguration = useSelector((state: RootState) => state.output)
  const settings = useSelector((state: RootState) => state.settings)

  return (
    <>
      <Button
        variant="functional"
        onClick={() => {
          downloadFile(createSVG({
            obstacles: inputConfiguration.obstacles,
            channels: [...Object.values(outputConfiguration.channels)].map(c => c.channel).filter(c => c !== undefined) as Channel[],
            settings
          }), nanoid() + '.svg')
        }}
        style={{
          margin: '1em'
        }}
      >
        Download SVG
      </Button>
    </>
  )
}

function createSVG({
  obstacles,
  channels,
  settings
}: {
  obstacles: Obstacle[]
  channels: Channel[]
  settings: Settings
}) {

  const extremalPoints: Point[] = []
  extremalPoints.push(...obstacles.flatMap(obstacle => obstacle.points))
  extremalPoints.push(...channels.flatMap(channel => channel.path.arcs.flatMap(a => {
    return [
      [a.center[0] + a.radius + channel.width, a.center[1]],
      [a.center[0] - a.radius - channel.width, a.center[1]],
      [a.center[0], a.center[1] + a.radius + channel.width],
      [a.center[0], a.center[1] - a.radius - channel.width]
    ] as Point[]
  })))

  const bbox = extremalPoints.length === 0 ? {
    minX: 0, maxX: 0, minY: 0, maxY: 0
  } : Geometry.boundingBox(extremalPoints)

  const obstaclesSVG = obstacles.map(obstacle => {
    return `<polygon
      points="${obstacle.points.map(p => p !== undefined ? `${p[0]},${p[1]}` : '').join(' ')}"
      fill="${settings.obstacleDefaultColor}"
      stroke="none"
    ></polygon>`
  }).join('')

  const channelsSVG = channels.map(channel => {
    return `<path
      d="${channel.path.pathString}"
      stroke="${settings.connectionDefaultColor}"
      stroke-width="${channel.width}"
      fill="none"
    ></path>`
  }).join('')

  const svg = `<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="${bbox.minX} ${bbox.minY} ${bbox.maxX - bbox.minX} ${bbox.maxY - bbox.minY}"
  >
    ${obstaclesSVG}
    ${channelsSVG}
  </svg>`

  return svg
}

function downloadFile(content: string, name: string) {
  const data = 'data:text/json;charset=utf-8,' + encodeURIComponent(content)
  const downloadAnchorNode = document.createElement('a')
  downloadAnchorNode.setAttribute('href', data)
  downloadAnchorNode.setAttribute('download', name)
  document.body.appendChild(downloadAnchorNode)
  downloadAnchorNode.click()
  downloadAnchorNode.remove()
}
